/* ck-card-quickbuy — product-card quick-buy overlay for brand collection grids
   and the CK product / related sliders.

   Injects a heart + quick-buy (plus) + rating overlay onto each .product-item.
   The plus button opens the theme's STANDARD quick-view MODAL for the card's
   REAL product, by reusing the <quick-view-product> custom element defined in
   component-quick-buy.js. No fake variants, no inline flip.

   Exposes window.ckCardQuickbuyInit(scope) so section scripts can (re)run the
   overlay after they inject cards (e.g. AJAX product-recommendations) WITHOUT
   dispatching a synthetic shopify:section:load event (that used to crash
   component-slider.js with "Cannot read properties of undefined (reading
   'contains')"). */

(function () {
  'use strict';

  var SVG_HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.5-9.5C1.2 8.4 3.4 5 7 5c2 0 3.7 1.1 5 2.8C13.3 6.1 15 5 17 5c3.6 0 5.8 3.4 4.5 6.5C19.5 16.4 12 21 12 21z" stroke-linejoin="round"/></svg>';
  var SVG_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg>';
  var SVG_STAR = '<svg viewBox="0 0 24 24"><path d="M12 2.5l2.95 6.4 7.05.7-5.3 4.85L18.2 21.5 12 17.7l-6.2 3.8 1.5-7.05L2 9.6l7.05-.7L12 2.5z"/></svg>';

  var DEMO_RATINGS = [
    { stars: 5, count: 286 },
    { stars: 5, count: 412 },
    { stars: 5, count: 94 },
    { stars: 5, count: 158 },
    { stars: 5, count: 47 },
    { stars: 5, count: 521 }
  ];

  function createEl(tag, className, html) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (html) el.innerHTML = html;
    return el;
  }

  function buildStars() {
    var s = '';
    for (var i = 0; i < 5; i++) s += SVG_STAR;
    return s;
  }

  function getProductUrl(card) {
    var a = card.querySelector('a.product-item__title[href]')
      || card.querySelector('a.product-item__image[href]')
      || card.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }

  function getProductId(card) {
    var m = (card.id || '').match(/product-item-(\d+)/);
    return m ? m[1] : '';
  }

  /* Open the theme's standard quick-view modal for this card's REAL product,
     reusing the <quick-view-product> custom element (component-quick-buy.js),
     which fetches "<product-url>?view=quick-view" and shows a modal-box. */
  /* Lazily build (once) the hidden <quick-view-product> for this card. Creating
     the element upgrades it (component-quick-buy.js), whose init() immediately
     warms the quick-view fetch — so calling this on hover pre-fetches the modal
     HTML before the shopper clicks. */
  function ensureQvp(card) {
    var url = getProductUrl(card);
    if (!url) { return null; }
    var qvp = card._ckQvp;
    if (!qvp) {
      // Build the markup as a STRING so <quick-view-product> is upgraded with
      // its <a> child already present. document.createElement upgrades the
      // element immediately (before children are appended), so its click
      // handler — which calls preventDefault — would never bind and the anchor
      // would navigate to the product page instead of opening the modal.
      var holder = createEl('div', 'ck-qb-modal-holder');
      holder.style.display = 'none';
      holder.innerHTML = '<quick-view-product><a href="' +
        url.replace(/"/g, '&quot;') + '" data-id="' + getProductId(card) +
        '"></a></quick-view-product>';
      card.appendChild(holder);
      qvp = holder.querySelector('quick-view-product');
      card._ckQvp = qvp;
    }
    return qvp;
  }

  /* Open the theme's standard quick-view modal for this card's REAL product,
     reusing the <quick-view-product> custom element (component-quick-buy.js),
     which shows a modal shell instantly then swaps in the fetched markup. */
  function openQuickView(card) {
    var qvp = ensureQvp(card);
    var anchor = qvp ? qvp.querySelector('a') : null;
    if (anchor) { anchor.click(); }
  }

  function setupCard(card, idx) {
    if (card.dataset.ckQuickbuy === 'on') return;
    card.dataset.ckQuickbuy = 'on';

    var imgEl = card.querySelector('.product-item__image');
    if (!imgEl) return;

    // Wrap the existing image (keeps the brand-grid overlay layout from the CSS).
    var inner = createEl('div', 'ck-flip-inner');
    imgEl.parentNode.insertBefore(inner, imgEl);
    inner.appendChild(imgEl);

    // Icon overlays over the photo.
    var heart = createEl('button', 'ck-qb-icon ck-qb-heart', SVG_HEART);
    heart.setAttribute('type', 'button');
    heart.setAttribute('aria-label', 'Add to wishlist');

    // Wishlist identity for this card (reuse the existing helpers).
    var _wlUrl = getProductUrl(card);
    var _wlHandle = _wlUrl ? _wlUrl.split('?')[0].split('#')[0].split('/').pop() : '';
    var _wlId = getProductId(card);
    if (_wlHandle) heart.dataset.ckHandle = _wlHandle;
    if (_wlHandle && window.SSWishlist && window.SSWishlist.has(_wlHandle)) {
      heart.classList.add('is-active');
      heart.setAttribute('aria-pressed', 'true');
      heart.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      heart.setAttribute('aria-pressed', 'false');
    }

    var plus = createEl('button', 'ck-qb-icon ck-qb-plus', SVG_PLUS);
    plus.setAttribute('type', 'button');
    plus.setAttribute('aria-label', 'Quick view');

    // Fake DEMO_RATINGS overlay removed 24 Jul 26 (Kym): static counts (286/412/94...)
    // cycled onto every thumbnail. Reviews now live on the PDP only (Judge.me widget).

    imgEl.appendChild(heart);
    imgEl.appendChild(plus);

    card.classList.add('ck-flip-on');

    // Warm the quick-view fetch on hover / press so the modal fills instantly.
    ['mouseenter', 'mousedown', 'focus', 'touchstart'].forEach(function (evt) {
      plus.addEventListener(evt, function () { ensureQvp(card); }, { passive: true });
    });

    // Quick-buy (plus) -> open the REAL product's quick-view modal.
    plus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openQuickView(card);
    });

    // Heart -> persist to the native wishlist store (localStorage) + live header count.
    heart.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!window.SSWishlist || !_wlHandle) { heart.classList.toggle('is-active'); return; }
      var active = window.SSWishlist.toggle({ handle: _wlHandle, id: _wlId });
      heart.classList.toggle('is-active', active);
      heart.setAttribute('aria-pressed', active ? 'true' : 'false');
      heart.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function init(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : null;
    if (!root) {
      var grid = document.querySelector('[data-section-type="main-collection-product-grid"], .main-collection-product-grid, .collection-grid, .product-grid');
      root = grid || document;
    }
    var cards = root.querySelectorAll('.product-item');
    cards.forEach(function (card, i) { setupCard(card, i); });
  }

  // Public entry point for section scripts (no synthetic events needed).
  window.ckCardQuickbuyInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-run on dynamic grid updates. Guard e.target — a stray/synthetic event
  // may have no element target.
  document.addEventListener('shopify:section:load', function (e) {
    var t = (e && e.target && e.target.querySelectorAll) ? e.target : null;
    init(t);
  });
  // Keep every heart on the page in sync with the store (multi-card, multi-tab, wishlist-page removes).
  document.addEventListener('ss:wishlist:change', function () {
    if (!window.SSWishlist) return;
    var hearts = document.querySelectorAll('.ck-qb-heart[data-ck-handle]');
    for (var i = 0; i < hearts.length; i++) {
      var h = hearts[i];
      var on = window.SSWishlist.has(h.getAttribute('data-ck-handle'));
      h.classList.toggle('is-active', on);
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      h.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  });

  document.addEventListener('collection:loaded', function () { init(); });
})();
